import api, {handleAPIErrors} from 'shared/api'

const FETCH_REQUEST = 'futureRemunerations/FETCH_REQUEST'
const FETCH_SUCCESS = 'futureRemunerations/FETCH_SUCCESS'
const FETCH_FAILURE = 'futureRemunerations/FETCH_FAILURE'
const DATA_RESET = 'futureRemunerations/DATA_RESET'

const dateResult = [{id: 0, date: ''}]

const prResult = {
    id: 0, threshold_from_range: '', threshold_to_range: '', threshold_from_pro_rated: '',
    threshold_to_pro_rated: null, threshold_pro_rated: false, target_from_range: '', target_to_range: '',
    target_from_pro_rated: '', target_to_pro_rated: '', target_pro_rated: false, max_range: '', max_pro_rated: '',
    reference_group: null, comment: '', threshold: null, target: null, maximum: null, disclosed: false,
    estimated: false
}
const {reference_group, disclosed, estimated, ...otherPRResponse} = prResult

const staCategory = {id: 0, percent: '', option: '', available: false, comment: ''}
const {option, ...otherSTACategory} = staCategory

const initialState = {
    remunerations: [{
        id: 0, role: '', show_base: false, show_sti: false, show_lti: false, show_restricted_share: false,
        company: {
            id: 0, code: '', name: '', market_capital: 0
        },
        fiscal_year: {
            id: 0, date: '', latest: false, actual_remuneration_disclosed: false
        },
        company_csuite_member: {
            id: 0, full_name: '', company_name: '', sector: '', seat_name: '', start_date: '', end_date: null,
            end_date_status: "", time_on_board_in_ms: 0, director_id: 0, company_id: 0, actual_job_title: '', gender: ''
        },
        base: {
            id: 0,
            bonus: '',
            bonus_super: false,
            comments: '',
            minimum_shareholding_requirement: '',
            number_of_years: ''
        },
        restricted_share: {
            id: 0,
            no_of_shares: '',
            receive_dividend: '',
            grant_date: '',
            vesting_dates: dateResult,
            payment_dates: dateResult,
            both_dates: dateResult
        },
        long_term_award: {
            id: 0,
            grant_date: '',
            base_percent: '',
            share_price: '',
            estimated: false,
            calculation_comment: '',
            comment: '',
            target_percent: '',
            max_percent: '',
            target_amount: '',
            max_amount: '',
            measurement_periods: [{
                id: 0, from_date: '', to_date: ''
            }],
            performance_right: {
                id: 0, threshold: '', target: '', maximum: '', total_shareholder: prResult, equity: prResult,
                compound_annual_growth: prResult, capital_employed: prResult,
                other_returns: [{
                    ...otherPRResponse, name: '', range_type: '%'
                }]
            }
        },
        short_term_award: {
            id: 0, comment: '', dollar_target: '', dollar_max: '', share_target: '', share_max: '', percent_target: '',
            percent_max: '', payment_cash: '', payment_share: '', deferred_pay_cash: '', deferred_pay_share: '',
            financial_percent: '', non_financial_percent: '', contribution_min: '', contribution_max: '',
            financial_categories: [staCategory],
            non_financial_categories: [staCategory],
            other_financial_categories: [{
                ...otherSTACategory, name: ''
            }],
            other_non_financial_categories: [{
                ...otherSTACategory, name: ''
            }]
        },
        retention_payment: {
            cash_reward: '',
            no_of_shares: "",
            value_of_shares: "",
            cash_deferred: false,
            cash_hurdle: false,
            shares_deferred: false,
            shares_hurdle: false,
            comment: ''
        }
    }],
    loaded: false,
    loading: false,
    errors: []
}

export function fetchRequest(payload = {}) {
    return {
        type: FETCH_REQUEST,
    }
}

export function resetData() {
    return {
        type: DATA_RESET,
    }
}

export function fetchSuccess(payload) {
    return {
        type: FETCH_SUCCESS,
        payload,
    }
}

export function fetchFailure(errors = []) {
    return {
        type: FETCH_FAILURE,
        errors,
    }
}

export function resetRemuneration() {
  return (dispatch) => {
    dispatch(resetData())
  }
}

export function loadData(options, cb = null) {
    return (dispatch) => {
        dispatch(fetchRequest())

        return api(`api/v1/future_remunerations`, options)
            .then(response => response.json().then(json => ({json, response})))
            .then(({json, response}) => {
                if (!response.ok) {
                    return Promise.reject(json)
                }

                dispatch(fetchSuccess(json))

                if (cb) cb()
            })
            .catch((exception) => {
                handleAPIErrors(exception, (errors) => {
                    dispatch(fetchFailure(errors))
                })

                if (cb) cb()
            })
    }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
    const {payload, type, errors} = action

    switch (type) {
        case FETCH_REQUEST:
            return Object.assign({}, state, {
                loading: true
            })
        case DATA_RESET:
            return Object.assign({}, state, {
                remunerations: [...state.remunerations.filter((rem) => rem.id == 0)]
            })
        case FETCH_SUCCESS:
            let modifiedRems = [];
            modifiedRems.splice(0, 0, ...state.remunerations.filter((rem) => rem.id == 0));
            modifiedRems.splice(1, 0, ...payload);

            return Object.assign({}, state, {
                loading: false,
                errors: [],
                remunerations: Object.assign(state.remunerations, modifiedRems),
            })
        case FETCH_FAILURE:
            return Object.assign({}, state, {
                loaded: false,
                loading: false,
                errors: errors
            })
        default:
            return state
    }
}

